/** These field types are internal and have automati values - fields of these types should not be shown to users. */
export const internalFieldTypes = [
  undefined,
  "",
  "start",
  "end",
  "today",
  "username",
  "simserial",
  "subscriberid",
  "deviceid",
  "phonenumber",
  "calculate",
];
